import './donut.style.scss';
import './../vignette.style.scss';
import { theme } from '../globalTheme';

import React from 'react';
import { ResponsivePie } from '@nivo/pie';
import { Flex, Col, Row } from 'antd';
import Button from '../../Button';

type DataObject = {
  label: string;
  value?: number;
  color?: string;
  data?: DataObject[];
};
interface DonutComponentProps {
  data: DataObject[];
  title: string;
}

const DonutComponent = ({ data, title }: DonutComponentProps) => {
  let _data: DataObject[] = data;
  let otherData: DataObject[] = [];
  if (data.length > 5) {
    const firstData = data.slice(1, 6);
    otherData = data.slice(5);

    _data = [...firstData, { label: 'Autres', data: otherData }];
  }

  const total = _data.reduce(
    (sum, data) => sum + (typeof data.value === 'number' ? data.value : 0),
    0
  );
  let dataWithPercentage = _data.map((data) => ({
    ...data,
    percentage:
      typeof data.value === 'number' && typeof total === 'number'
        ? Math.round((data.value / total) * 100)
        : 0,
  }));

  return (
    <Row
      justify="space-between"
      align="middle"
      className="vignette donut-vignette"
    >
      <Col span={15}>
        <Row gutter={[12, 24]}>
          <Col span={24}>
            <header className="donut-vignette__title">{title}</header>
          </Col>
          <div className="donut-vignette__ledgend-wrapper">
            {dataWithPercentage.map(
              (data) =>
                typeof data.value === 'number' && (
                  <Col key={data.value}>
                    <Flex gap="middle">
                      <div
                        className="donut-vignette__ledgend-color"
                        style={{
                          background: data && data.color,
                        }}
                      />
                      <Flex vertical>
                        <p className="donut-vignette__ledgend-label">
                          {data && data.label.split('-')[0].trim()}
                        </p>
                        <p className="donut-vignette__ledgend-label">
                          {data &&
                            data.label.split('-')[1] &&
                            data.label.split('-')[1].trim()}
                        </p>
                      </Flex>
                    </Flex>

                    <div className="donut-vignette__ledgend-percentage">
                      {data.percentage}%
                    </div>
                  </Col>
                )
            )}
            {otherData.length > 0 && (
              <div className="donut-vignette__more-info">
                <Button
                  type="button"
                  className="visibility-button "
                  onClick={() => {}}
                  text={dataWithPercentage[5].label}
                />
              </div>
            )}
          </div>
        </Row>
      </Col>

      <Col span={9} className="donut-vignette__chart-wrapper">
        <ResponsivePie
          data={data}
          innerRadius={0.55}
          padAngle={2}
          cornerRadius={15}
          colors={(d) => d.data.color}
          enableArcLabels={false}
          enableArcLinkLabels={false}
          theme={theme}
        />
      </Col>
    </Row>
  );
};

export default DonutComponent;
